import * as React from 'react'
import styled from 'styled-components/macro'
import Planning from 'assets/images/HomeImages/Planning.jpg'
import Gifts from 'assets/images/HomeImages/Gifts.jpg'
import OnCourse from 'assets/images/HomeImages/OnCourse.jpg'
import {QUERIES} from 'common/constants'
import {Link} from 'react-router-dom'

const Container = styled.div`
  display: none;
  flex-direction: column;
  width: 100%;
  background-color: var(--dark-grey);
  padding: 16px 0;
  @media ${QUERIES.tabletAndUp} {
    display: flex;
    background-color: inherit;
    padding: 0;
    flex-direction: row;
    justify-content: center;
    align-items: flex-end;
    position: absolute;
    bottom: 0;
  }
  gap: 16px;
`

const MobileContainer = styled(Container)`
  display: flex;
  @media ${QUERIES.tabletAndUp} {
    display: none;
  }
`

const ImageContainer = styled(Link)`
  text-decoration: none;
  :hover {
    img {
      height: 150px;
      filter: grayscale(0%);
    }
    div {
      background-color: var(--darker-grey);
    }
  }
  cursor: pointer;
`

const LinkContainer = styled(Link)`
  text-decoration: none;
`

const ServiceImage = styled.img`
  display: none;
  @media ${QUERIES.tabletAndUp} {
    display: flex;
  }
  width: 384px;
  object-fit: cover;
  object-position: bottom;
  filter: grayscale(100%);
  height: 125px;
  transition: all 0.5s ease;
`
const ImageTitle = styled.div`
  display: flex;
  justify-content: center;
  background-color: var(--darker-grey);
  padding: 8px 0;
  text-decoration: underline;
  @media ${QUERIES.tabletAndUp} {
    text-decoration: none;
    padding: 0;
    background-color: #525252;
  }

  color: white;
  width: 100%;
  font-family: 'Rubik';
  font-size: clamp(1rem, 3vw, 2rem);
  font-style: italic;
  text-transform: uppercase;
`

const HomeServices = () => {
  return (
    <>
      <Container>
        <ImageContainer to="/planning">
          <ServiceImage src={Planning} />
          <ImageTitle>Planning</ImageTitle>
        </ImageContainer>
        <ImageContainer to="/gifts">
          <ServiceImage src={Gifts} />
          <ImageTitle>Gifts</ImageTitle>
        </ImageContainer>
        <ImageContainer to="/oncourse">
          <ServiceImage src={OnCourse} />
          <ImageTitle>On-Course</ImageTitle>
        </ImageContainer>
      </Container>
      <MobileContainer>
        <LinkContainer to="/planning">
          <ServiceImage src={Planning} />
          <ImageTitle>Planning</ImageTitle>
        </LinkContainer>
        <LinkContainer to="/gifts">
          <ServiceImage src={Gifts} />
          <ImageTitle>Gifts</ImageTitle>
        </LinkContainer>
        <LinkContainer to="/oncourse">
          <ServiceImage src={OnCourse} />
          <ImageTitle>On-Course</ImageTitle>
        </LinkContainer>
      </MobileContainer>
    </>
  )
}
export default HomeServices
